

import appsettings from '@/store/app-settings'
import {axiosGet, axiosPost}  from '@/store/api/axiosUtils.js'

const getDocumentForUserApprove = (params) => {
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Approve/DocumentForUserApprove', params)
}

const getDocumentTrackingDetailByUser = (params) => {    
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Document/GetDocumentTrackingDetailByUser', params)
}


export {getDocumentForUserApprove, getDocumentTrackingDetailByUser}